export enum CompanyRoleEnum {
  BUSINESS_ANALYST = 'Business Analyst',
  DIRECTOR = 'Director',
  QA_ENGINEER = 'QA Engineer',
  DEVELOPER = 'Developer',
  SCRUM_MASTER = 'Scrum Master',
  MANAGER = 'Manager',
  NONE = 'None',
  PRODUCT_MANAGER = 'Product Manager',
  TEAM_LEAD = 'Team Lead',
  PRODUCT_OWNER = 'Product Owner',
  EXECUTIVE_BOARD_MEMBER = 'Executive Board Member',
  PROJECT_MANAGER = 'Project Manager',
  DEVOPS_ENGINEER ='DevOps Engineer',
  TECH_LEAD = 'Tech Lead',
  AGILE_COACH = 'Agile Coach',
  TRIBE_LEAD = 'Tribe Lead',
}
